<template>
  <v-container fluid class="px-3 pt-0 pedidos-filtros">
    <v-row>
      <v-col>
        <div class="filter-box">
          <label class="box-label">Lojas</label>
          <mf-select-units-dialog
            hide-details
            required
            check-all-units-on-init
            enable-inactive-units-selection
            solo
            :selected-units.sync="filter.units"
            :units="units"
            :tag-list="tagList"
            :group-list="unitsGroups"
          />
        </div>
      </v-col>

      <v-col>
        <div class="filter-box">
          <label class="box-label">Responsável</label>
          <v-text-field v-model="filter.agent" solo hide-details placeholder="Digite o nome"></v-text-field>
        </div>
      </v-col>

      <v-col>
        <div class="filter-box">
          <label class="box-label">Cliente</label>
          <v-text-field v-model="filter.clientName" solo hide-details placeholder="Digite o nome"></v-text-field>
        </div>
      </v-col>

      <v-col>
        <div class="filter-box">
          <label class="box-label">Tipo de pedido</label>
          <v-row>
            <v-checkbox v-model="filter.pickup" hide-details single-line class="mt-2 mr-3" label="Retirada" />
            <v-checkbox v-model="filter.delivery" hide-details single-line class="mt-2" label="Entrega" />
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    filter: Object,
  },
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
  },
}
</script>

<style lang="scss">
.pedidos-filtros {
  .filter-box {
    .box-label {
      opacity: 0.5;
      font-family: Lato;
      font-size: 12px;
      line-height: 1.25;
      letter-spacing: 0.19px;
      color: $preto;
    }
  }
}
</style>
